import { render } from "./Customer_Account.vue?vue&type=template&id=336af494&scoped=true"
import script from "./Customer_Account.vue?vue&type=script&lang=js"
export * from "./Customer_Account.vue?vue&type=script&lang=js"

import "./Customer_Account.vue?vue&type=style&index=0&id=336af494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336af494"]])

export default __exports__